module.exports = __webpack_public_path__ + "img/istockphoto-1944772735-612x612.ddd9670a.jpg";